import { getAPIFromDomain } from "lib/api";

export type FeatureFlag = {
  state: boolean;
  flag: string;
};

export const fetchFeatureFlag = async (flag: string) => {
  const api = getAPIFromDomain();
  api.defaults.baseURL = api?.defaults?.baseURL?.replace("/v1", "");
  const url = `feature-flags/${flag}`;
  const response = await api.get(url);

  return response.data as FeatureFlag;
};
